import React from 'react';

const PERMISSION_LABELS = {
  pos: 'Punto de Venta',
  menu: 'Menú',
  supplies: 'Insumos',
  sales: 'Ventas',
  costing: 'Costeo',
  admin: 'Admin',
  analysis: 'Análisis',
  costStructure: 'Estructura de Costos',
  inventory: 'Inventario',
  dashboard: 'Dashboard',
  comandas: 'Comandas',                   // 🔥 NUEVO
  ticketSettings: 'Configuración Ticket' // 🔥 NUEVO
};

const UserList = ({
  users = [],
  onDeleteUser,
  onEditUser
}) => {
  // 🔒 Blindaje total: si no es array, no renderiza filas
  const safeUsers = Array.isArray(users) ? users : [];

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-[#58735A]">
        <thead className="bg-[#58735A]">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
              Usuario
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
              Permisos
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
              Acciones
            </th>
          </tr>
        </thead>

        <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">
          {safeUsers.length === 0 && (
            <tr>
              <td
                colSpan={3}
                className="px-4 py-6 text-center text-sm text-[#3F1907]"
              >
                No hay usuarios para mostrar
              </td>
            </tr>
          )}

          {safeUsers.map((user) => {
            // 🔒 Blindaje del campo access
            let access = {};

            try {
              if (typeof user?.access === 'string') {
                access = JSON.parse(user.access) || {};
              } else if (
                typeof user?.access === 'object' &&
                user.access !== null
              ) {
                access = user.access;
              }
            } catch (e) {
              access = {};
            }

            const permissionsText =
              Object.entries(access)
                .filter(([_, value]) => Boolean(value))
                .map(([key]) => PERMISSION_LABELS[key] || key)
                .join(', ') || 'Ninguno';

            return (
              <tr key={user.id ?? user.username}>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                  {user.username || '—'}
                </td>

                <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                  {permissionsText}
                </td>

                <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907] space-x-2">
                  {user.username !== 'admin' && (
                    <>
                      <button
                        onClick={() => onEditUser?.(user)}
                        className="text-blue-500 hover:text-blue-700 transition duration-200"
                      >
                        Editar
                      </button>

                      <button
                        onClick={() => onDeleteUser?.(user.id)}
                        className="text-red-500 hover:text-red-700 transition duration-200"
                      >
                        Eliminar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserList;

